var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"studentMessageHome"},[_c('div',{staticClass:"navBox"},[_c('ul',{staticClass:"navRight"},_vm._l((_vm.navRight),function(item,index){return _c('router-link',{key:index,attrs:{"tag":"li","to":{
          path: _vm.infor.version == '2' ? item.path : item.path1,
        }}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])}),1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }